import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'countByKey',
  pure: true,
  standalone: true,
})
export class CountByKeyPipe implements PipeTransform {
  transform<T, K extends keyof T & string>(array: T[], key: K): Record<Extract<T[K], string>, number> {
    const countByValue = {} as Record<Extract<T[K], string>, number>;

    array.forEach((elem) => {
      const value = elem[key] as Extract<T[K], string> | undefined;
      if (value !== undefined) {
        countByValue[value] = (countByValue[value] || 0) + 1;
      }
    });

    return countByValue;
  }
}
